/* ============================================================
   Culture — Gift with purchase
   Auto-adds / removes a free gift line based on a rule. The gift
   variant is priced $0.00, so it is free without any discount.
   Works with assets/cart.js (CartAPI + the 'cart:updated' event).

   The gift is identified by VARIANT ID (not just the _gift line
   property), so a scrunchie added directly from the product page
   (no _gift property) is still treated as the gift: collapsed to a
   single qty-1 line and never counted as a qualifying purchase.
   ============================================================ */
(function () {
  var CFG = window.__CULTURE_GWP__ || {};
  if (!CFG.enabled || !CFG.variantId) return;

  var PROP = CFG.property || '_gift';
  var VARIANT = String(CFG.variantId);
  var MIN = parseInt(CFG.minSubtotal, 10) || 0;
  var reconciling = false;

  function hasGiftProp(item) {
    return !!(item && item.properties && item.properties[PROP]);
  }
  function isGiftVariant(item) {
    return !!(item && String(item.variant_id) === VARIANT);
  }

  /* Classify the cart:
     - giftLines: every line of the gift variant (however it was added)
     - stale:     a line flagged _gift but pointing at an OLD gift variant
     - qualifying: everything that is NOT the gift variant */
  function evaluate(cart) {
    var giftLines = [], stale = null, qualSubtotal = 0, qualCount = 0;
    (cart.items || []).forEach(function (it) {
      if (isGiftVariant(it)) { giftLines.push(it); return; }
      if (hasGiftProp(it)) { stale = it; return; } /* old gift variant, drop it */
      if (it.gift_card) { return; } /* gift cards don't earn the free scrunchie */
      qualSubtotal += it.final_line_price;
      qualCount += it.quantity;
    });
    /* keep the line that already carries the _gift property if present */
    giftLines.sort(function (a, b) { return (hasGiftProp(b) ? 1 : 0) - (hasGiftProp(a) ? 1 : 0); });
    var desired = qualCount > 0 && qualSubtotal >= MIN;
    return { giftLines: giftLines, stale: stale, desired: desired };
  }

  /* One mutation per pass. After a mutation the pass SELF-CHAINS another
     pass so the cart converges within a single page load — e.g. swapping a
     stale gift needs two mutations (remove old, add new) and we must not
     rely on the cart:updated event to re-trigger us (our own reconciling
     guard swallows the event we fire mid-pass, which would otherwise leave
     the cart giftless until the next load). Returns a promise resolving to
     true when a mutation was performed. */
  function reconcilePass() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var st = evaluate(cart);

        /* 1. drop a stale gift (settings changed to a new variant) */
        if (st.stale) {
          return window.CartAPI.change(st.stale.key, 0).then(function () { return true; });
        }

        if (st.desired) {
          /* 2. no gift yet → add one */
          if (st.giftLines.length === 0) {
            var props = {};
            props[PROP] = 'true';
            return window.CartAPI.add(
              { id: VARIANT, quantity: 1, properties: props },
              false, /* don't open the drawer */
              true   /* silent: no error toast */
            ).then(function () { return true; });
          }
          /* 3. more than one gift line (e.g. added again from the PDP) →
                remove the extras, keep the first */
          if (st.giftLines.length > 1) {
            return window.CartAPI.change(st.giftLines[1].key, 0).then(function () { return true; });
          }
          /* 4. exactly one gift line but qty ≠ 1 → lock to 1 */
          if (st.giftLines[0].quantity !== 1) {
            return window.CartAPI.change(st.giftLines[0].key, 1).then(function () { return true; });
          }
        } else {
          /* 5. cart no longer qualifies → remove any/all gift lines */
          if (st.giftLines.length > 0) {
            return window.CartAPI.change(st.giftLines[0].key, 0).then(function () { return true; });
          }
        }
        return false; /* nothing to do — converged */
      });
  }

  function reconcile() {
    if (reconciling) return;
    if (!window.CartAPI) return;
    reconciling = true;

    /* run passes back-to-back until the cart converges (guard against a
       runaway loop with a small pass cap) */
    var passes = 0;
    function step() {
      return reconcilePass().then(function (mutated) {
        passes += 1;
        if (mutated && passes < 6) return step();
      });
    }
    step()
      .catch(function () {})
      .finally(function () { reconciling = false; });
  }

  /* react to every cart mutation (guarded against our own changes) */
  document.addEventListener('cart:updated', function () {
    if (!reconciling) reconcile();
  });

  /* initial pass on load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
